export default "__VITE_ASSET__9ebc3898__"